import { Component, OnInit, NgZone } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ValidationsService } from '../../services/common/validations.service';
import { DashboardService } from '../../services/dashboard.service';
@Component({
  selector: 'app-assessment-coupons',
  templateUrl: './assessment-coupons.component.html',
  styleUrls: ['./assessment-coupons.component.scss']
})
export class AssessmentCouponsComponent implements OnInit {

  isLoading = true;

  optionForm: FormGroup;

  // Stats and Buy More
  couponDetailsAndPriceResponse;
  isBuyMoreClicked = false;
  buyMoreSuccessEventMessage;

  getPurchasedCouponsPostData = {
    filterByType: Number,
    orderBy: 'date desc',
    search: '',
    download: '',
    offset: ''
  };
  purchasedCouponsList;
  purchasedCouponsListForCsvDownload;
  fileName = 'Purchased Coupons List';

  // Pagination
  noOfPages;

  // assign Coupon
  packageTypeSelectDropdown = []; // planSelect1, planSelect2, ...

  serialNumber = 1;

  constructor(private zone: NgZone, private formBuilder: FormBuilder, private validationService: ValidationsService, private dashboardService: DashboardService) {
    // subscribe to Coupons Bought Success flag
    this.dashboardService.getCouponBoughtFlag().subscribe(data => {
      // console.log('get coupon flag', data);
      this.zone.run(() => {
        // this.couponDetailsAndPriceResponse.couponsBought = this.couponDetailsAndPriceResponse.couponsBought + parseInt(data.couponCount);
        // this.couponDetailsAndPriceResponse.couponRemainingCount = this.couponDetailsAndPriceResponse.couponRemainingCount + parseInt(data.couponCount);
        this.getPartnerCouponDetails();
        this.getPurchasedCouponsList();
        this.isBuyMoreClicked = !this.isBuyMoreClicked; // or set it to false
      });
    });
  }

  ngOnInit() {
    this.optionForm = this.formBuilder.group({
      filterByType: ['']
    });

    this.getPartnerCouponDetails();


    this.getPurchasedCouponsList();


    this.optionForm.get('filterByType').valueChanges.subscribe(optedValue => {
      this.getPurchasedCouponsPostData.filterByType = optedValue;
      this.getPurchasedCouponsPostData.offset = '';

      this.getPurchasedCouponsList();
    });
  }

  // only number input
  onlyNumericInput(event) {
    return this.validationService.isNumericInput(event);
  }

  // get stats and Buy More Popup Info
  getPartnerCouponDetails() {
    this.dashboardService.getPartnerCouponDetails().subscribe(response => {
      this.isLoading = false;
      // console.log(response);
      if (response.statusCode == 200 && response.status == false) {
        console.log('no data');
      }
      else if (response.statusCode == 200 && response.status == true) {
        this.couponDetailsAndPriceResponse = response.data;
      }
    },
      error => {
        console.log('error handled in component-- ', error);
      });
  }

  // Buy More
  buyMoreClickAction() {
    this.isBuyMoreClicked = !this.isBuyMoreClicked;
  }

  // Coupons table
  getPurchasedCouponsList() {
    this.dashboardService.getPurchasedCouponsList(this.getPurchasedCouponsPostData).subscribe(response => {
      // console.log(response);
      if (response.status == true && response.statusCode == 200) {
        if (response.data != null) {
          if (this.getPurchasedCouponsPostData.download == '1') {
            this.getPurchasedCouponsPostData.download = '';
            this.purchasedCouponsListForCsvDownload = response.data.couponDetails;
            this.dashboardService.exportToCsvService(this.fileName, this.purchasedCouponsListForCsvDownload);
          }
          else {
            // creating select drop-downs (dynamic)
            this.packageTypeSelectDropdown = [];  // resetting the array, otherwise new fields are appended to it.
            (response.data.couponDetails).forEach((coupon, index) => {
              // selects will be generated with names as planSelect1, planSelect2, ...
              // STARTS with '1' i.e. planSelect1
              this.packageTypeSelectDropdown.push({ name: ('planSelect' + (index + 1)), value: (coupon.package_id == 2 && coupon.staged_at == 3) ? 3 : coupon.package_id });
              // INFO - if package_id == 2 and staged_at == 3, then 'college'
            });

            this.purchasedCouponsList = response.data.couponDetails;
            this.noOfPages = response.data.couponCount;
          }
        }
      }
      else if (response.status == false && response.statusCode == 200) {
        this.purchasedCouponsList = null;
      }
    });
  }

  // Download CSV
  downloadCsv() {
    this.getPurchasedCouponsPostData.download = '1';
    this.getPurchasedCouponsList();
  }

  // Assign Purchased coupon
  assignPurchasedCoupon(itemIndex, dropdownSelectedPackageValue, couponCode) {
    const assignPurchasedCouponPostData = {
      coupon: couponCode,
      package: parseInt(dropdownSelectedPackageValue)
    };

    this.dashboardService.assignPurchasedCoupon(assignPurchasedCouponPostData).subscribe(response => {
      if (response.statusCode == 200 && response.status == true) {
        this.purchasedCouponsList[itemIndex].package_id = dropdownSelectedPackageValue;
      }
    });
  }

  // Paginate (with serialNumber update)
  paginate(event) {
    this.serialNumber = event.first + 1;
    this.getPurchasedCouponsPostData.offset = (event.first);
    this.getPurchasedCouponsList();
  }

}
